import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";

/**
 * @returns {function:Cache}
 */
function jsonCache() {
  return function (Cache) {
    var JSONCache =
    /*#__PURE__*/
    function (_Cache) {
      _inherits(JSONCache, _Cache);

      function JSONCache() {
        _classCallCheck(this, JSONCache);

        return _possibleConstructorReturn(this, _getPrototypeOf(JSONCache).apply(this, arguments));
      }

      _createClass(JSONCache, [{
        key: "read",

        /**
         * @override
         * @public
         * @returns {any}
         */
        value: function read() {
          return JSON.parse(_get(_getPrototypeOf(JSONCache.prototype), "read", this).call(this));
        }
        /**
         * @override
         * @public
         * @param {any} data
         * @return {void}
         */

      }, {
        key: "write",
        value: function write(data) {
          return _get(_getPrototypeOf(JSONCache.prototype), "write", this).call(this, JSON.stringify(data));
        }
      }]);

      return JSONCache;
    }(Cache);

    return JSONCache;
  };
}

export default jsonCache;